import kbpgp from 'kbpgp'
import noop from 'lodash/noop'
import {promisify} from 'utils/promise.utils'

import {PROGRESS, KEY_STRENGTHS, KEYGEN_OPTIONS} from './const'

const ASP_PROGRESS = {
  FERMAT: 'fermat',
  FOUND: 'found',
}

export default async ({
  userid,
  passphrase,
  strength = KEY_STRENGTHS.LOW,
  progressHook = noop,
}) => {
  const asp = new kbpgp.ASP({
    progress_hook: function({what, p}) {
      if (what === ASP_PROGRESS.FERMAT) {
        progressHook({
          progress: PROGRESS.FINDING_PRIME,
          value: p && p.shortValue && p.shortValue(),
        })
      }
      if (what === ASP_PROGRESS.FOUND) {
        progressHook({
          progress: PROGRESS.FOUND_PRIME,
          value: p && p.shortValue && p.shortValue(),
        })
      }
    },
  })

  const baseOptions =
    KEYGEN_OPTIONS[strength] || KEYGEN_OPTIONS[KEY_STRENGTHS.LOW]
  const opts = {...baseOptions, userid, asp}

  // generate key with provided settings
  progressHook(PROGRESS.START_GENERATION)
  const key = await promisify(kbpgp.KeyManager.generate, kbpgp.KeyManager)(opts)
  progressHook(PROGRESS.END_GENERATION)

  // sing the key
  progressHook(PROGRESS.START_SIGNING)
  await promisify(key.sign, key)({asp})
  progressHook(PROGRESS.END_SIGNING)

  // get public and private keys
  progressHook(PROGRESS.START_EXPORT_PUBLIC)
  progressHook(PROGRESS.START_EXPORT_PRIVATE)
  const [pub, pri] = await Promise.all([
    promisify(
      key.export_pgp_public,
      key
    )({asp}).then(k => {
      progressHook(PROGRESS.END_EXPORT_PUBLIC)
      return k
    }),
    promisify(
      key.export_pgp_private,
      key
    )({passphrase, asp}).then(k => {
      progressHook(PROGRESS.END_EXPORT_PRIVATE)
      return k
    }),
  ])

  return {public: pub, private: pri}
}
